<template>
  <div class="position-relative" v-on-clickaway="clickOutside">
    <button
      type="button"
      :class="['select--dropdown', { open: dropdown }, { error }, { disabled }]"
      @click="selectDropdown"
    >
      <span
        v-if="
          (!loopSelected || !(loopSelected && loopSelected.length)) && multiple
        "
        class="select--dropdown__label"
        >{{ label }}</span
      >
      <span
        v-if="!multiple"
        :class="[
          'select--dropdown__label',
          {
            'with--data': !!(selected && selected[0] && selected[0].value)
          }
        ]"
        >{{ (selected && selected[0] && selected[0].label) || label }}</span
      >
      <div v-if="multiple" class="d-flex">
        <div ref="itemContainer" class="d-flex">
          <div
            v-for="(val, key) in loopSelected"
            :id="val.value"
            :key="key"
            class="select--dropdown__item"
          >
            {{ val.label }}
            <img
              src="~@/assets/media/icons/close.svg"
              alt="close icon"
              class="select--dropdown__remove"
              @click="e => $emit('removeItem', { e, val })"
            />
          </div>
        </div>
        <div
          v-if="limitView && selected.length - loopSelected.length > 0"
          class="select--dropdown__item external"
        >
          {{ `+${excessCount} more` }}
        </div>
      </div>
      <img
        src="~@/assets/media/icons/icon-down-arrow.svg"
        alt="info icon"
        :class="['select--dropdown__icon', { open: dropdown }]"
      />
    </button>
    <ul v-if="dropdown" class="dropdown--list">
      <li v-for="(val, key) in lists" :key="key" class="dropdown--list__item">
        <div
          v-if="multiple"
          class="css-control css-control-inline css-checkbox select-checkbox"
        >
          <input
            v-if="multiple"
            type="checkbox"
            class="css-control-input"
            :id="`qty-toggle-${val.value}`"
            @click="() => handleToggle(val, key)"
            :checked="val.toggle"
            :disabled="disabledCheckbox"
          />
          <label class="css-control-label" :for="`qty-toggle-${val.value}`">{{
            val.label || ""
          }}</label>
        </div>
        <div v-else>
          <span class="single--label" @click="() => handleToggle(val, key)">{{
            val.label || ""
          }}</span>
        </div>
      </li>
      <div
        v-if="!(lists && lists.length)"
        class="d-flex justify-content-center"
      >
        No items available
      </div>
    </ul>
  </div>
</template>

<script>
import { mixin as clickaway } from "vue-clickaway";
export default {
  mixins: [clickaway],
  props: {
    lists: {
      type: [Array, Object],
      default: null
    },
    label: {
      type: String,
      default: ""
    },
    error: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    multiple: {
      type: Boolean,
      default: true
    },
    selected: {
      type: [Array, Object],
      default: null
    },
    disabledCheckbox: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    dropdown: false,
    elementWidth: 0,
    loopSelected: [],
    limitCount: 0,
    excessCount: 0,
    limitView: false
  }),
  mounted() {
    if (!this.multiple) return;
    this.updateWidth();
  },
  updated() {
    if (!this.multiple) return;
    this.updateWidth();
    if (!this.limitView) {
      this.loopSelected = this.selected;
    }
  },
  watch: {
    elementWidth(value) {
      if (!this.multiple) return;
      if (this.limitCount && this.limitView) {
        this.loopSelected = this.selected.filter(
          (_, key) => key < this.limitCount
        );
      }
      this.limitView = value > 250;
    },
    limitView(value) {
      if (!this.multiple) return;
      const display = (this.selected && this.selected.length) || 0;
      this.limitCount = value ? display : 0;
    },
    selected(value) {
      if (!this.multiple) return;
      if (!value) {
        this.loopSelected = [];
        return;
      }
      if (value && this.loopSelected) {
        const diplayedSelected = this.loopSelected.map(v => v.value);
        this.excessCount = value.filter(
          v => !diplayedSelected.includes(v.value)
        ).length;
        if (this.excessCount < 1) {
          this.loopSelected = value;
        }
      }
    }
  },
  methods: {
    selectDropdown() {
      this.dropdown = !this.dropdown;
    },
    updateWidth() {
      this.elementWidth = this.$refs.itemContainer.clientWidth;
    },
    clickOutside() {
      this.dropdown = false;
    },
    handleToggle(val, key) {
      if (!this.multiple) {
        this.dropdown = false;
      }
      this.$emit("handleToggle", { val, key });
    }
  }
};
</script>

<style lang="scss" scoped>
.select--dropdown {
  display: flex;
  width: 100%;
  position: relative;
  border: 1px solid #949494;
  border-radius: 4px;
  background: #ffffff;
  height: 40px;
  padding: 0 8px;
  cursor: pointer;
  align-items: center;

  &.open {
    border: 1px solid #00b3c1;
  }

  &.error {
    border-color: #fa533d;
  }

  &.disabled {
    border-color: #b7b7b7;
    pointer-events: none;
  }

  &__label {
    color: #949494;
    padding: 0 8px;
    font-family: "Nunito Sans";
    font-size: 0.875rem;
    font-weight: 400;
    line-height: 1.25rem;
    letter-spacing: 0rem;

    &.with--data {
      color: #4c4c4c;
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
      padding-right: 16px;
    }
  }

  &__icon {
    width: 8px;
    height: 8px;
    transition: 300ms;
    position: absolute;
    right: 16px;
    &.open {
      transform: rotate(180deg);
    }
  }

  &__item {
    display: flex;
    background: #f2fbfc;
    border: 1px solid #bfecf0;
    border-radius: 4px;
    color: #4c4c4c;
    font-size: 12px;
    padding: 3px 9px;
    align-items: center;
    &:not(:last-child) {
      margin-right: 4px;
    }
    &.external {
      margin-left: 4px;
    }
  }

  &__remove {
    width: 8px;
    height: 8px;
    margin-left: 10px;
  }
}

.dropdown--list {
  list-style: none;
  padding: 1rem;
  border: 1px solid #dddddd;
  box-shadow: 0px 3px 10px #00000014;
  border-radius: 4px;
  background: #fff;
  overflow-x: hidden;
  overflow-y: auto;
  max-height: 146px;
  gap: 1rem;
  display: flex;
  flex-direction: column;
  position: absolute;
  width: 100%;
  top: 38px;
  z-index: 10;

  &__item {
    display: flex;
    flex-direction: row;
  }

  .select-checkbox {
    .css-control-input {
      &:disabled ~ .css-control-label {
        color: #b7b7b7;

        &::before {
          background-color: transparent;
          border-color: #b7b7b7;
        }
      }

      &:checked ~ .css-control-label {
        color: #505050;

        &::before {
          background-color: var(--primary, #51b67e);
        }
      }
    }
  }
}
.single--label {
  font-weight: 500;
  font-size: 0.75rem;
  cursor: pointer;
}
</style>
